export const agentFeedbackToTranslationKeyMap: { [key: string]: string } = {
  'Potential spelling errors in the text': 'spellingError',
  'Small design issues': 'smallIssue',
  'Embroidery simplification needed': 'simplification',
  'Image background that needs to be removed': 'removeBackground',
  'Necessary colour change to design elements': 'colorChange',
  'Opportunity to better match the original design': 'betterMatch',
  "Made customer's edits (no changes)": 'customerEdits',
};
